import { FALLBACK_IMAGES_THEME } from 'theme/fallback-images'

// secondary fallback image is unnessesary now, it was added for future implementations( in current implementation it can be only svg Icon)
export const FALLBACK_IMAGES = {
  DEFAULT: FALLBACK_IMAGES_THEME.DEFAULT,
  SECONDARY: FALLBACK_IMAGES_THEME.SECONDARY,
  AVATAR: FALLBACK_IMAGES_THEME.AVATAR,
}
